import { Component, OnInit } from '@angular/core';

import * as firebase from 'firebase';
import * as moment from 'moment';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-submit-banner',
  templateUrl: './submit-banner.component.html',
  styleUrls: ['./submit-banner.component.css']
})
export class SubmitBannerComponent implements OnInit {

  loading: boolean = false;

  key: string = "";

  banner: any = {};
  file: any;
  imagePreview: any;

  constructor(private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.key = params['id'];
      if (this.key)
        this.getBanner();
    });
  }

  getBanner() {
    firebase.database().ref(`/banners/${this.key}`)
      .once("value")
      .then(snapshot => {
        this.banner = snapshot.val();

        if (!this.banner) {
          this.router.navigate([`all-sponsers`]);
        }
      })
  }

  onChangeFile(event: EventTarget) {
    let eventObj: MSInputMethodContext = <MSInputMethodContext>event;
    let target: HTMLInputElement = <HTMLInputElement>eventObj.target;
    let files: FileList = target.files;
    this.file = files[0];

    this.showImage(this.file);
  }

  showImage(file) {
    var fr = new FileReader();
    fr.onload = () => {
      this.imagePreview = fr.result;
    }
    fr.readAsDataURL(file);
  }

  async save() {
    if (!this.file && !this.banner.image) {
      return alert("Please select image");
    } else if (!this.banner.link) {
      return alert("Please enter link");
    } else if (!this.banner.expiry) {
      return alert("Please enter expiry");
    }

    var date = moment(this.banner.expiry).toDate();

    date.setHours(23, 59, 59, 0);

    this.banner.expiryTime = Number(date);

    this.banner.timestamp = Number(new Date());

    this.loading = true;

    if (this.file) {
      var url = await this.saveFile();

      this.banner.image = url;
    }

    if (!this.key) {
      await firebase.database().ref("banners").push(this.banner);
    } else {
      await firebase.database().ref(`/banners/${this.key}`).set(this.banner);
    }

    this.loading = false;
    alert("Banner added");

    this.router.navigate([`all-sponsers`]);
  }

  saveFile() {
    let storageRef = firebase.storage().ref();
    const filename = Math.floor(Date.now() / 1000);

    return storageRef.child('banners/' + filename + this.file.name).put(this.file)
      .then(snapshot => {
        return snapshot.ref.getDownloadURL();
      })
      .catch(err => {
        alert(err.message);
        console.log(err);
      })
  }

  async deleteBanner() {
    if (!confirm("Are you sure want to delete this banner?")) {
      return;
    }

    await firebase.database().ref(`/banners/${this.key}`).remove();

    this.router.navigate([`all-sponsers`]);
  }

}
